import { projectManagementApi } from '@/includes/projectManagementApi';

const pmProjectService = {
  async listProjects({ scope } = {}) {
    const params = scope ? { scope } : undefined;
    const response = await projectManagementApi.get('/projects', { params });
    return response.data;
  },

  async getProject(id) {
    const response = await projectManagementApi.get(`/projects/${id}`);
    return response.data;
  },

  async createProject(payload) {
    const response = await projectManagementApi.post('/projects', payload);
    return response.data;
  },

  async updateProject(id, payload) {
    const response = await projectManagementApi.patch(`/projects/${id}`, payload);
    return response.data;
  },

  async deleteProject(id) {
    const response = await projectManagementApi.delete(`/projects/${id}`);
    return response.data;
  },
};

export default pmProjectService;
